import {
  LOAD_SONG_TOP_CITIES,
  UNLOAD_CURRENT_ARTIST,
  UNLOAD_CURRENT_SONG,
} from '../../actionTypes';
import { loadReducer } from '../helpers';

export const topCities = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
    case UNLOAD_CURRENT_SONG:
      return null;

    case LOAD_SONG_TOP_CITIES:
      return loadReducer(state, action);
    default:
      return state;
  }
};
